export default __webpack_public_path__ + "img/video-camera.29a4ea95.svg";